/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from "./store/index"
import Vuelidate from 'vuelidate'
import PaperDashboard from "./plugins/paperDashboard";
import vSelect from 'vue-select';
import { ModalPlugin, SpinnerPlugin, TablePlugin, TabsPlugin, PaginationPlugin } from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faUsers, faCertificate, faTable, faReceipt, faCheck, faTimes, faAngleDown, faAngleRight, faAngleUp, faSearch, faQuestion, faDownload, faClipboardCheck, faDesktop, faArchive } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import ToggleButton from 'vue-js-toggle-button';
import RecursiveRow from "./components/Tables/RecursiveRow.vue";
import RecursiveRows from "./components/Tables/RecursiveRows.vue";
import "notyf/notyf.min.css";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-select/src/css/vue-select.css';
import "./filters";

// font awesome fonts
library.add(faUser, faUsers, faCertificate, faDesktop, faTable, faReceipt, faCheck, faTimes, faAngleDown, faAngleRight, faAngleUp, faSearch, faQuestion, faDownload, faClipboardCheck, faArchive);

Vue.use(Vuelidate);
Vue.use(PaperDashboard);
Vue.use(ModalPlugin);
Vue.use(SpinnerPlugin);
Vue.use(TablePlugin);
Vue.use(TabsPlugin);
Vue.use(PaginationPlugin);
Vue.use(ToggleButton);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('date-picker', DatePicker);
Vue.component('v-select', vSelect);

// register recursive components globally
Vue.component('recursive-row', RecursiveRow);
Vue.component('recursive-rows', RecursiveRows);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
